import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import CannedVegsFruitsProduct from 'models/CannedVegsFruitsProduct'
import CannedVegsFruitsPackage from './CannedVegsFruitsPackage'

const productOptions = {
  packagingInfo: <CannedVegsFruitsPackage />,
  productTitle: 'Canned Fruits/Vegetables',
  model: CannedVegsFruitsProduct,
  validCategories: ['19'],
  validSubCategories: ['001CF', '001CV'],
}

const CannedVegsFruitsFruits = () => <ProductForm product={productOptions} />

export default CannedVegsFruitsFruits

export const getCannedVegFruitsPackage = newProduct => {
  let newCannedVegFruitsPackage = {
    UPC: newProduct.UPC,
    CannedProductType: newProduct.CannedProductType,
    Size: newProduct.Size,
    Packaged: newProduct.Packaged,
    OrganicVerification: newProduct.OrganicVerification,
    ItemType:
      newProduct.ItemType === 'Other'
        ? newProduct.otherType
        : newProduct.ItemType,
    ContainerType:
      newProduct.ContainerType === 'Other'
        ? newProduct.otherContainerType
        : newProduct.ContainerType,
  }

  if (newProduct.CannedProductType === 'Fruit') {
    newCannedVegFruitsPackage.FruitPackageCertification =
      newProduct.noAddtlIngredients || newProduct.FruitPackageCertification
    newCannedVegFruitsPackage.PackedIn =
      newProduct.packageType || newProduct.PackedIn
  } else {
    newCannedVegFruitsPackage.VegetablePackageCertification =
      newProduct.noAddtlIngredients || newProduct.VegetablePackageCertification
    newCannedVegFruitsPackage.SaltContent =
      newProduct.packageType || newProduct.SaltContent
  }

  return newCannedVegFruitsPackage
}

export const updateCannedVegFruitsPackage = newProduct => {
  let newCannedVegFruitsPackage = {
    UPC: newProduct.UPC,
    CannedProductType: newProduct.CannedProductType,
    Size: newProduct.Size,
    Packaged: newProduct.Packaged,
    OrganicVerification: newProduct.OrganicVerification,
    ItemType:
      newProduct.ItemType === 'Other'
        ? newProduct.otherType
        : newProduct.ItemType,
    ContainerType:
      newProduct.ContainerType === 'Other'
        ? newProduct.otherContainerType
        : newProduct.ContainerType,
  }
  newProduct.noAddtlIngredients
    ? (newCannedVegFruitsPackage.NoAddedIngredients =
        newProduct.noAddtlIngredients)
    : (newCannedVegFruitsPackage.NoAddedIngredients =
        newProduct.NoAddedIngredients)

  newCannedVegFruitsPackage.CannedProductType = newProduct.CannedProductType

  if (newCannedVegFruitsPackage.CannedProductType === 'Fruit') {
    newProduct.packageType
      ? (newCannedVegFruitsPackage.PackedIn = newProduct.packageType)
      : (newCannedVegFruitsPackage.PackedIn = newProduct.PackedIn)

    newProduct.noAddtlIngredients
      ? (newCannedVegFruitsPackage.FruitPackageCertification =
          newProduct.noAddtlIngredients)
      : (newCannedVegFruitsPackage.FruitPackageCertification =
          newProduct.FruitPackageCertification)
  } else {
    newProduct.packageType
      ? (newCannedVegFruitsPackage.SaltContent = newProduct.packageType)
      : (newCannedVegFruitsPackage.SaltContent = newProduct.SaltContent)

    newProduct.noAddtlIngredients
      ? (newCannedVegFruitsPackage.VegetablePackageCertification =
          newProduct.noAddtlIngredients)
      : (newCannedVegFruitsPackage.VegetablePackageCertification =
          newProduct.VegetablePackageCertification)
  }

  return newCannedVegFruitsPackage
}
